import React from 'react'

const SobreNosotros = () => (
  <section className="section">
    <h2>Quiénes Somos</h2>
    <div className="tarjetas">
      <div className="tarjeta">
        <h3>Experiencia</h3>
        <p>Más de 10 años en el sector ingenieril, con proyectos exitosos en diversas industrias.</p>
      </div>
      <div className="tarjeta">
        <h3>Compromiso</h3>
        <p>Nos dedicamos a la excelencia y la satisfacción del cliente en cada proyecto.</p>
      </div>
      <div className="tarjeta">
        <h3>Equipo</h3>
        <p>Profesionales calificados comprometidos con la innovación y la calidad.</p>
      </div>
    </div>
  </section>
)

export default SobreNosotros